import * as  React from 'react';
import HeaderPartSeparator from '../HeaderPartSeparator/HeaderPartSeparator';

type PageNameProps = {
    name: string
}
function PageName({ name }: PageNameProps) {
    return <React.Fragment>
        <HeaderPartSeparator height={32} classes="page-name-sep" />
        <div className="page-name">{name}</div>
    </React.Fragment>;
}

export default PageName;